import { Button } from "@mui/material";
import { UpcomingSessionInfo } from "../clockLayout/UpcomingSessionInfo";
import { RoomParams } from "../../pages/Room";
import { useTheme } from "@emotion/react";
import { getThemeColor } from "../../utils/color";
import PhaseLinearTimeline from "./PhaseLinearTimeline";

export const LinearLayoutRoomDisplay = (params: RoomParams) => {
    const {
        room,
        inside,
        isPlayingAudio,
        currentSessionInfo,
        upcomingPhases,
        pastPhases,
        enterRoom,
    } = params;
    const {
        currentSession,
        upcomingSession,
        upcomingSessionIsTomorrow,
        timeUntilUpcomingSession
    } = currentSessionInfo;

    const theme = useTheme() as any;
    const roomColor = getThemeColor(theme, room.color);
   
    return (
        <div
            className={"linear-room " +
                (inside ? "inside" : "outside") +
                (isPlayingAudio && inside ? " is-playing-audio" : "") +
                (currentSession ? " session" : " pause")
            }
            id={"room-" + room.name}
        >
            <div className="timeline">
                {currentSession
                    ? // display linear layout: (Intention)--(Vorbereitung)--(Aktivierung)--(Achtsamkeit)--((Focccus-Zeit 12:20))--(Abschluss)
                    <div className="text-center">

                        {/* TODO display linar layout here, depending on:
                        - currentPhase
                        - upcomingPhases
                        - currentSessionRunningTime
                        - roomColor (for progress bar color)
                        - roomColorSecondary (for the border of the PhaseNodes + connector segments)
                        - roomColorTertiary (for the background of the PhaseNodes + connector segments)
                     */}

                        <PhaseLinearTimeline
                            inside={inside}
                            isPlayingAudio={isPlayingAudio}
                            pastPhases={pastPhases}
                            upcomingPhases={upcomingPhases}
                            room={room}
                        />

                    </div>
                    : // display pause image and pcoming session: name, start time of day (local time! local time format!)
                    <div className="text-center">
                        <UpcomingSessionInfo
                            timeUntilUpcomingSession={timeUntilUpcomingSession}
                            upcomingSession={upcomingSession}
                            upcomingSessionIsTomorrow={upcomingSessionIsTomorrow}
                            roomColor={roomColor} />
                    </div>
                }

            </div>
            <div className="enter-room-button-wrapper">
                {!inside && <>
                    <Button
                        key="enter-room"
                        variant='contained'
                        color={room.color as any}
                        size="small"
                        fullWidth={false}
                        onClick={enterRoom}
                        sx={{
                        }}
                    >
                        Audio aktivieren &nbsp; ▶
                    </Button>
                </>
                }
            </div>
        </div>
    );
}

export default LinearLayoutRoomDisplay;